document.addEventListener("alpine:init", () => {
    Alpine.data("contentSwitcher", () => ({
      currentIndex: 0,
      itemsCount: 0,
      timer: 0,
      interval: null,
  
      init() {
        this.itemsCount = this.$el.querySelectorAll(".Content__Switcher__button").length;
        this.startTimer();
      },
  
      selectItem(index, event) {
        this.currentIndex = index;
        this.startTimer();

        // Only scroll on tablet and mobile (width < 1024px)
        if (event && window.innerWidth < 1024) {
          this.$nextTick(() => {
            const element = event.target;
            const offset = 85;
            const elementTop = element.getBoundingClientRect().top;
            const finalScroll = window.scrollY + elementTop - offset;

            window.scrollTo({
              top: finalScroll,
              behavior: "smooth",
            });
          });
        }
      },

      handleClick(index, event) {
        // Mobile/tablet: tap switches content (no hover available)
        if (window.innerWidth < 1024) {
          this.selectItem(index, event);
          return;
        }

        const button = event.currentTarget;
        const url = button.dataset.linkUrl;
        if (!url) return;

        const target = button.dataset.linkTarget || "_self";
        if (target === "_blank") {
          window.open(url, "_blank", "noopener,noreferrer");
        } else {
          window.location.href = url;
        }
      },
      
      nextItem() {
        this.currentIndex = (this.currentIndex + 1) % this.itemsCount;
        this.startTimer();
      },
  
      startTimer() {
        clearInterval(this.interval);
        this.timer = 0;
        this.interval = setInterval(() => {
          this.timer += 100;
          if (this.timer >= 10000) this.nextItem();
        }, 100);
      },
  
      get progress() {
        return (this.timer / 10000) * 100;
      },
    }));
  });
  